module.exports = __webpack_public_path__ + "img/en_text_recolored.6865f45d.svg";